<template>
  <ca-footer>
    <ca-row vertical-offset="2">
      <ca-col size="2">
        <ca-button full-width @click="onBack">
          {{ backLabel }}
        </ca-button>
      </ca-col>
      <ca-col offset="8" size="2">
        <ca-submit-button>
          {{ saveLabel }}
        </ca-submit-button>
      </ca-col>
    </ca-row>
  </ca-footer>
</template>

<script>
export default {
  name: 'WorkerFormFooter',
  props: {
    onBack: {
      type: Function,
      required: true,
    },
    backLabel: {
      type: String,
      default: 'Anterior',
    },
    saveLabel: {
      type: String,
      default: 'Próximo',
    },
  },
};
</script>
